import axios from 'axios'

export default {
  async getProtocolRequest (protocolId) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'protocols/' + protocolId,
        method: 'GET'
      }).then(response => {
        resolve(response.data.protocol)
      }).catch(error => {
        reject(error.response.data)
      })
    })
  },
  async getProtocol (protocolId) {
    return this.getProtocolRequest(protocolId)
  },
  async updateProtocol (protocol, sendMails = false) {
    return new Promise((resolve, reject) => {
      let rooms = []
      for (let room of protocol.rooms) {
        room.images_amount = 1
        rooms.push(Object.assign({}, room))
        room.images = []
      }
      axios({
        url: protocol.api_id !== undefined ? 'protocols/' + protocol.api_id : 'protocols',
        data: {
          date: protocol.date,
          object: protocol.object,
          street: protocol.street,
          tenant: protocol.tenant,
          signature_tenant: protocol.signature_tenant,
          signature_inspector: protocol.signature_inspector,
          signature_owner: protocol.signature_owner,
          signature_old_tenant: protocol.signature_old_tenant,
          protocol: JSON.stringify(protocol),
          email_owner: protocol.email_owner,
          email_old_tenant: protocol.email_old_tenant,
          email_tenant: protocol.email_tenant,
          email_inspector: protocol.email_inspector,
          send_mails: sendMails
        },
        method: protocol.api_id !== undefined ? 'PUT' : 'POST'
      }).then(async (resp) => {
        await this.updateImages(resp.data.protocol.id, rooms, sendMails)
        resolve(resp.data.protocol.id)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  async updateImages (protocolId, rooms, sendMails) {
    return new Promise(async (resolve, reject) => {
      for await (let room of rooms) {
        if (room.images !== undefined) {
          if (room.images.length > 0) {
            let images = room.images
            await axios({
              url: 'protocols/' + protocolId + '/' + room.id,
              data: {images},
              method: 'POST'
            }).then(response => {
            }).catch(error => {
              console.log(error)
            })
          }
        }
      }
      if (sendMails) {
        this.sendMails(protocolId)
      }
      resolve()
    })
  },
  sendMails (protocolId) {
    axios({
      url: 'protocols/' + protocolId + '/mails/send',
      method: 'PUT'
    }).then(response => {
      return protocolId
    }).catch(error => {
      return error
    })
  }
}



// WEBPACK FOOTER //
// ./src/functions/api.js